import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryCreator } from "redux/baseQuery";

import env from "env";
import { GetAuditRecordRequest, GetAuditRecordResponse, ResponseAuditActivityType } from "./types";

const { auditService } = env.api.baseUrl;
const baseQuery = fetchBaseQuery({
  baseUrl: auditService,
  prepareHeaders: (headers, { getState }: any) => {
    const token = getState().auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const auditApi = createApi({
  reducerPath: "auditApi",
  baseQuery: baseQueryCreator(baseQuery),
  endpoints: (builder) => ({
    getAuditRecords: builder.mutation<GetAuditRecordResponse, GetAuditRecordRequest>({
      query: ({ ...params }) => {
        return {
          url: `/audit-records`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            ...params,
          },
        };
      },
    }),
    getListActivityType:  builder.mutation<ResponseAuditActivityType, {}>({
      query: () => {
        return {
          url: `/audit-categories`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        };
      },
    }),
  }),
});

export const { useGetAuditRecordsMutation, useGetListActivityTypeMutation } = auditApi;
